import React from "react";
import "../App.css";

export default function Privacy() {
  return (
    <>
      <section className="privacy-hero">
        <div className="container">
          <h1>
            PRIVACY <span>POLICY</span>
          </h1>

          <p className="privacy-company">
            Selenean Technologies Private Limited
          </p>

          <div className="privacy-meta">
            <span>Effective date: 13 August 2026</span>
            <span className="privacy-meta-divider">|</span>
            <span>Last updated: 13 August 2026</span>
          </div>
        </div>
      </section>

      <section className="privacy-page">
        <div className="container">
          <p className="privacy-intro">
            Selenean Technologies Private Limited (CIN:
            U26100KA2024PTC194103) ("Selenean", "Company", "we", "us" or "our")
            is committed to protecting the privacy of individuals whose personal
            data we process. This Privacy Policy explains how we collect, use,
            disclose and safeguard personal data when you visit our website, or
            otherwise interact with us, and describes your rights as a Data
            Principal under the Digital Personal Data Protection Act, 2023
            ("DPDPA") and the Digital Personal Data Protection Rules, 2025
            ("DPDP Rules"). This Policy should be read together with our Terms of
            Use and Cookie Policy.
          </p>

          <article className="privacy-body">
            <section id="definitions" className="privacy-section">
              <h2>
                <span className="privacy-num">1.</span>DEFINITIONS
              </h2>

              <p>1.1. In this Policy:</p>

              <ul className="privacy-list">
                <li>
                  <span className="privacy-letter">(a)</span>
                  <span>
                    <strong>"Data Fiduciary"</strong> means Selenean, who alone
                    or jointly with others determines the purpose and means of
                    processing Personal Data;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(b)</span>
                  <span>
                    <strong>"Data Principal"</strong> means the individual to
                    whom Personal Data relates, and, where that individual is a
                    child, includes their parent or lawful guardian;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(c)</span>
                  <span>
                    <strong>"Data Processor"</strong> means any person who
                    processes Personal Data on behalf of Selenean;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(d)</span>
                  <span>
                    <strong>"Personal Data"</strong> means any data about an
                    individual who is identifiable by or in relation to such
                    data;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(e)</span>
                  <span>
                    <strong>"Processing"</strong> means any operation performed
                    on Personal Data, including collection, storage, use,
                    sharing, disclosure or erasure.
                  </span>
                </li>
              </ul>
            </section>

            <section id="scope" className="privacy-section">
              <h2>
                <span className="privacy-num">2.</span>SCOPE AND APPLICABILITY
              </h2>

              <p>
                2.1. This Policy applies to Personal Data we process in digital
                form (or digitised non-digital Personal Data) in connection with
                the services, our website, and our sales, marketing, support and
                recruitment activities. By accessing our website, you
                acknowledge that you have read and understood this Privacy
                Policy. If you do not agree with the practices described here,
                please discontinue accessing our website.
              </p>
            </section>

            <section id="data-we-collect" className="privacy-section">
              <h2>
                <span className="privacy-num">3.</span>PERSONAL DATA WE COLLECT
              </h2>

              <p>
                3.1. We collect Personal Data that you provide directly, and data
                collected automatically when you interact with our digital
                properties:
              </p>

              <ul className="privacy-list">
                <li>
                  <span className="privacy-letter">(a)</span>
                  <span>
                    <strong>Identity and contact data:</strong> full name, email
                    address, phone number, postal address, job title, company
                    name and professional affiliations;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(b)</span>
                  <span>
                    <strong>Usage data:</strong> IP address, browser type and
                    version, operating system, device identifiers, pages
                    visited, click paths, referral URLs, search queries, and
                    date/time stamps of access;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(c)</span>
                  <span>
                    <strong>Cookie and tracking data:</strong> as described in
                    Clause 8 (Cookies and Tracking Technologies) and our Cookie
                    Policy.
                  </span>
                </li>
              </ul>

              <p>
                3.2. We collect only the Personal Data reasonably necessary for
                the purposes described in Clause 5 (Purpose and Legal Basis of
                Processing), consistent with the DPDPA's data minimisation
                principle.
              </p>
            </section>

            <section id="how-we-collect" className="privacy-section">
              <h2>
                <span className="privacy-num">4.</span>HOW WE COLLECT PERSONAL
                DATA
              </h2>

              <p>
                4.1. We collect Personal Data: (a) directly from you, such as
                when you submit a form, or contact support; (b) automatically,
                through cookies and similar technologies as you interact with our
                website; and (c) from third parties, such as business partners or
                publicly available professional directories, where permitted by
                applicable law.
              </p>
            </section>

            <section id="purpose" className="privacy-section">
              <h2>
                <span className="privacy-num">5.</span>PURPOSE AND LEGAL BASIS OF
                PROCESSING
              </h2>

              <p>
                5.1. We process Personal Data on the basis of your consent, or
                where processing constitutes a "legitimate use" recognised under
                Section 7 of the DPDPA (for example, where you have voluntarily
                provided Personal Data for a specified purpose and have not
                indicated you do not consent, or where processing is necessary to
                comply with a legal obligation, respond to a medical emergency,
                or perform an employment-related function).
              </p>

              <p>
                5.2. Where we rely on consent, that consent will be free,
                specific, informed, unconditional and unambiguous, given through
                clear affirmative action, and limited to the Personal Data
                necessary for the stated purpose, as further described in Clause
                6 (Consent Management).
              </p>
            </section>

            <section id="consent" className="privacy-section">
              <h2>
                <span className="privacy-num">6.</span>CONSENT MANAGEMENT
              </h2>

              <p>
                6.1. Before or at the time we seek your consent, we will give you
                notice describing the Personal Data we intend to process, the
                purpose of processing, and how you may exercise your rights or
                lodge a complaint with the Data Protection Board of India.
              </p>

              <p>
                6.2. You may withdraw consent at any time, and withdrawal will be
                as easy as giving consent. Withdrawal does not affect the
                lawfulness of processing carried out before withdrawal; we will
                cease processing your Personal Data within a reasonable time of
                withdrawal, or as required by applicable law, cause any Data
                Processor engaged by us to do the same. Where you have engaged a
                registered Consent Manager, you may also give, manage or withdraw
                consent through that Consent Manager.
              </p>
            </section>

            <section id="how-we-use" className="privacy-section">
              <h2>
                <span className="privacy-num">7.</span>HOW WE USE YOUR PERSONAL
                DATA
              </h2>

              <p>7.1. We use Personal Data for the following purposes:</p>

              <ul className="privacy-list">
                <li>
                  <span className="privacy-letter">(a)</span>
                  <span>
                    <strong>Communication:</strong> sending service-related
                    notices and, where you have opted in, marketing
                    communications;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(b)</span>
                  <span>
                    <strong>Improvement and analytics:</strong> analysing usage
                    patterns to improve our website and services, and detecting
                    and preventing technical issues and security threats; and
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(c)</span>
                  <span>
                    <strong>Legal compliance:</strong> complying with applicable
                    law and enforcing our Terms of Use and this Policy.
                  </span>
                </li>
              </ul>
            </section>

            <section id="cookies" className="privacy-section">
              <h2>
                <span className="privacy-num">8.</span>COOKIES AND TRACKING
                TECHNOLOGIES
              </h2>

              <p>
                8.1. We use cookies, web beacons, pixel tags and similar
                technologies to collect information about your browsing activity,
                administer our site, and understand how visitors use it. Full
                details of the categories of cookies we use, their purposes, and
                how to manage your preferences are set out in our Cookie Policy.
              </p>
            </section>

            <section id="disclosure" className="privacy-section">
              <h2>
                <span className="privacy-num">9.</span>DISCLOSURE OF PERSONAL
                DATA
              </h2>

              <p>
                9.1. Selenean does not sell Personal Data. We may disclose
                Personal Data only in the following circumstances:
              </p>

              <ul className="privacy-list">
                <li>
                  <span className="privacy-letter">(a)</span>
                  <span>
                    <strong>Data Processors:</strong> we engage third-party
                    vendors (cloud hosting, payment processing, analytics, email
                    delivery and customer support providers) to process Personal
                    Data on our behalf, only under a valid written contract that
                    binds them to protect that Personal Data;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(b)</span>
                  <span>
                    <strong>Legal requirements:</strong> where required by law,
                    regulation, legal process, or an enforceable governmental
                    request, or where we believe in good faith that disclosure is
                    necessary to protect our rights, your safety, or to
                    investigate fraud; and
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(c)</span>
                  <span>
                    <strong>Business transfers:</strong> in connection with a
                    merger, acquisition, reorganisation or sale of assets, in
                    which case we will notify you by email or a prominent notice
                    on our website of any change in ownership or use of your
                    Personal Data.
                  </span>
                </li>
              </ul>

              <p>
                9.2. Where Personal Data we hold is likely to be used to make a
                decision affecting you, or is disclosed to another Data
                Fiduciary, we take reasonable steps to ensure it is complete,
                accurate and consistent before that use or disclosure.
              </p>
            </section>

            <section id="cross-border" className="privacy-section">
              <h2>
                <span className="privacy-num">10.</span>CROSS-BORDER TRANSFER OF
                PERSONAL DATA
              </h2>

              <p>
                Selenean operates globally and may transfer and process Personal
                Data outside India. Consistent with Section 16 of the DPDPA, we
                may transfer Personal Data to any country or territory outside
                India except where such transfer is restricted by the Central
                Government by notification. Where we transfer Personal Data
                internationally, we impose contractual and technical safeguards
                on the recipient consistent with this Policy and take reasonable
                measures to ensure the transferred data remains protected.
              </p>
            </section>

            <section id="retention" className="privacy-section">
              <h2>
                <span className="privacy-num">11.</span>DATA RETENTION
              </h2>

              <p>
                We retain Personal Data only for as long as necessary to fulfil
                the purposes described in Clause 5 (Purpose and Legal Basis of
                Processing), to comply with our legal, accounting or regulatory
                obligations, or to establish, exercise or defend legal claims,
                after which it is securely deleted or anonymised. Where you
                withdraw consent or your specified purpose is no longer being
                served and retention is not otherwise required by law, we will
                erase your Personal Data, and require our Data Processors to do
                the same, unless retention is necessary for a legal proceeding.
              </p>
            </section>

            <section id="security" className="privacy-section">
              <h2>
                <span className="privacy-num">12.</span>DATA SECURITY
              </h2>

              <p>
                We implement reasonable technical and organisational measures to
                protect Personal Data against unauthorised access, alteration,
                disclosure or destruction. No method of transmission or storage
                is completely secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section id="rights" className="privacy-section">
              <h2>
                <span className="privacy-num">13.</span>YOUR RIGHTS AS A DATA
                PRINCIPAL
              </h2>

              <p>
                13.1. Subject to applicable law, you have the following rights in
                relation to your Personal Data:
              </p>

              <ul className="privacy-list">
                <li>
                  <span className="privacy-letter">(a)</span>
                  <span>
                    <strong>Right to access:</strong> to obtain a summary of the
                    Personal Data we process about you, the processing activities
                    undertaken, and the identities of Data Fiduciaries and Data
                    Processors with whom it has been shared;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(b)</span>
                  <span>
                    <strong>Right to correction and erasure:</strong> to request
                    correction, completion, updating or erasure of your Personal
                    Data;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(c)</span>
                  <span>
                    <strong>Right to grievance redressal:</strong> to have your
                    complaint addressed through our grievance redressal process
                    described in Clause 14 (Grievance Redressal), which you must
                    exhaust before approaching the Data Protection Board of
                    India; and
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(d)</span>
                  <span>
                    <strong>Right to nominate:</strong> to nominate another
                    individual to exercise your rights on your behalf in the
                    event of your death or incapacity.
                  </span>
                </li>
              </ul>

              <p>
                13.2. To exercise any of these rights, contact us using the
                details in Clause 16 (Contact Us). We will respond within thirty
                (30) days, or as required by applicable law.
              </p>
            </section>

            <section id="grievance" className="privacy-section">
              <h2>
                <span className="privacy-num">14.</span>GRIEVANCE REDRESSAL
              </h2>

              <p>
                14.1. In accordance with the DPDPA and DPDP Rules, Selenean has
                appointed the following Grievance Officer to address complaints
                regarding the processing of your Personal Data:
              </p>

              <ul className="privacy-list privacy-officer">
                <li>
                  <span className="privacy-letter">(a)</span>
                  <span>
                    <strong>Name:</strong> Sundeep Dasa
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(b)</span>
                  <span>
                    <strong>Designation:</strong> Corporate Relations
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(c)</span>
                  <span>
                    <strong>Email:</strong> sundeep@univisiontechnocon.com
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(d)</span>
                  <span>
                    <strong>Address:</strong> Nandi Infotech, KIADB Plot No. 8,
                    1st Cross, Sadaramangala Road, Mahadevapura Post, Bengaluru
                    – 560048
                  </span>
                </li>
              </ul>

              <p>
                14.2. The Grievance Officer will acknowledge your complaint and
                endeavour to resolve it within thirty (30) days of receipt. If
                you are not satisfied with our response, or do not receive a
                response within the prescribed period, you may escalate your
                complaint to the appropriate authorities under applicable law..
              </p>
            </section>

            <section id="children" className="privacy-section">
              <h2>
                <span className="privacy-num">15.</span>CHILDREN'S DATA AND
                PERSONS WITH DISABILITIES
              </h2>

              <p>
                15.1. Our website and services are not directed at children
                (individuals under the age of 18), and we do not knowingly
                process a child's Personal Data without verifiable consent from
                their parent or lawful guardian. We do not undertake tracking,
                behavioural monitoring, or targeted advertising directed at
                children, and we do not process children's data in a manner
                likely to cause them detrimental effect.
              </p>

              <p>
                15.2. If you believe we have inadvertently collected a child's
                Personal Data without appropriate consent, please contact us
                using the details in Clause 16 (Contact Us), and we will take
                steps to erase it promptly.
              </p>
            </section>

            <section id="contact" className="privacy-section">
              <h2>
                <span className="privacy-num">16.</span>CONTACT US
              </h2>

              <p>
                16.1. If you have questions, concerns or requests regarding this
                Policy or our data practices, please contact us, you may visit
                our Contact Page and submit your questions, concerns or requests,
                as the case may be;
              </p>

              <p>
                16.2. We aim to respond to all legitimate requests within thirty
                (30) calendar days. If your request is particularly complex, or
                you have made multiple requests, it may take us longer, in which
                case we will notify you and keep you updated on our progress.
              </p>
            </section>

            <section id="changes" className="privacy-section">
              <h2>
                <span className="privacy-num">17.</span>CHANGES TO THIS POLICY
              </h2>

              <p>
                17.1. We may update this Policy to reflect changes in our
                practices, technologies or legal requirements. When we make
                material changes, we will update the "Last updated" date above
                and, where appropriate, provide additional notice such as an
                email or a banner on our website. We encourage you to review this
                Policy periodically. This Policy, together with our Terms of Use
                and Cookie Policy, forms the complete legal framework governing
                how Selenean handles your Personal Data.
              </p>
            </section>
          </article>
        </div>
      </section>
    </>
  );
}
